module.exports = __webpack_public_path__ + "img/red-hammock-between-wall-3255245.62f020b9.jpg";